<template>
    <div>
      <div class="rounded-lg text-center">
        <div class="rounded-lg" style="background-color: rgba(63, 81, 181, 0.8); color: white;">
          <h1 class="ml-4 pt-2">Diagnóstico de Habilidades Digitales</h1>
        </div>
      </div>
  
      <!-- Instrucciones en el encabezado -->
      <v-card flat class="my-4 mx-4 pa-4">
        <v-card-title class="text-justify">
          {{ instructions }}
        </v-card-title>
      </v-card>
  
      <!-- Tabs para las secciones -->
      <v-tabs v-model="currentTab" grow color="deep-purple">
        <v-tab v-for="(sectionName, index) in sectionNames" :key="index">
          <v-icon left>mdi-format-list-checks</v-icon>
          {{ sectionName }}
        </v-tab>
      </v-tabs>
  
      <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
        <v-col cols="12" class="text-center">
          <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
          <div class="mt-4 text-h6">Cargando...</div>
        </v-col>
      </v-row>

      <!-- Contenido de las tabs -->
      <v-tabs-items v-else v-model="currentTab" touchless>
        <!-- Sección 1: Datos generales -->
        <v-tab-item :key="0">
          <v-card flat>
            <v-card class="mb-6">
              <v-divider></v-divider>
              <div v-for="(question, index) in questionsBySection[0]" :key="index" class="pa-4">
                <v-card class="mt-4 pa-2">
									<v-card-title class="white--text book-paragraph primary d-flex">
										<div>
											<v-icon left color="white">mdi-comment-question</v-icon>
											<span>{{ `Pregunta ${index + 1}: ${question.text}` }}</span>
										</div>
										<v-spacer></v-spacer>
										<div class="question-status">
											<v-chip :color="getQuestionStatusColor(question.id)" dark>
												{{ getQuestionStatus(question.id) ? 'Respondida' : 'Pendiente' }}
											</v-chip>
										</div>
									</v-card-title>
  
                  <v-card-text>
                    <!-- Single Choice (Sexo) -->
                    <v-container v-if="question.type === 'single_choice'" class="d-flex">
                      <v-radio-group v-model="studentReply[question.id].answerId"  @change="saveToLocalStorage">
                        <v-radio
                          v-for="option in question.options"
                          :key="`option-${question.id}-${option.id}`"
                          :value="option.id"
                          color="success"
													class="pa-2"
                        >
                          <template v-slot:label>
                            <span class="px-2">{{ option.text }}</span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-container>
  
                    <!-- Multiple Choice (Equipos) -->
                    <v-container v-if="question.type === 'multiple_choice'" class="options-container">
                      <v-checkbox
                        v-for="option in question.options"
                        :key="`moption-${question.id}-${option.id}`"
                        :label="option.text"
                        :value="option.id"
                        v-model="studentReply[question.id].answerId"
                        @change="saveToLocalStorage"
                        color="success"
                        class="custom-checkbox"
                      >
                        <template v-slot:label>
                          <span :class="{
                            'selected-option': isChecked(question.id, option.id)
                          }">
                            {{ option.text }}
                          </span>
                        </template>
                      </v-checkbox>
                    </v-container>
                  </v-card-text>
  
                  <v-card-actions v-if="showError[question.id]">
                    <v-alert type="error" class="mt-2">Debe responder esta pregunta.</v-alert>
                  </v-card-actions>
                </v-card>
              </div>
            </v-card>
						<v-card-actions class="d-flex justify-center">
              <v-btn  
                @click="nextSection" 
                class="white--text custom-btn" 
                color="deep-purple accent-4" >
                Siguiente
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
  
        <!-- Sección 2: Habilidades digitales -->
        <v-tab-item :key="1">
          <v-card flat>
            <v-card class="mb-6">
              <v-divider></v-divider>
              <div v-for="(question, index) in questionsBySection[1]" :key="index" class="pa-4">
                <v-card class="mt-4 pa-2">
                  <v-card-title class="white--text book-paragraph primary d-flex">
										<div >
											<v-icon left color="white">mdi-comment-question</v-icon>
											<span>{{ `Pregunta ${index + 1}: ${question.text}` }}</span>
										</div>
										<v-spacer></v-spacer>
										<div class="question-status">
											<v-chip :color="getQuestionStatusColor(question.id)" dark>
												{{ getQuestionStatus(question.id) ? 'Respondida' : 'Pendiente' }}
											</v-chip>
										</div>
									</v-card-title>
  
                  <v-card-text>
                    <!-- Single Choice para habilidades digitales (todas tienen mismas opciones) -->
                      <v-radio-group v-model="studentReply[question.id].answerId"  @change="saveToLocalStorage">
                        <v-radio
                          v-for="option in question.options"
                          :key="`option-${question.id}-${option.id}`"
                          :value="option.id"
                          color="success"
													class="pa-2"
                        >
                          <template v-slot:label>
                            <span class="px-2">{{ option.text }}</span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                  </v-card-text>
  
                  <v-card-actions v-if="showError[question.id]">
                    <v-alert type="error" class="mt-2">Debe responder esta pregunta.</v-alert>
                  </v-card-actions>
                </v-card>
              </div>
            </v-card>
  
            <v-card-actions class="d-flex justify-center">
              <v-btn
                @click="submit"
                x-large
								class="white--text custom-btn" 
                color="deep-purple accent-4" 
              >
                Terminar Diagnóstico
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

    </div>
  </template>
  
  <script>
  import axios from "axios";
  import Swal from "sweetalert2";
  
  export default {
    data() {
      return {
        questionsBySection: [],
        instructions: "",
        studentReply: {},
        timeSpent: 0,
        showError: {},
        currentTab: 0,
        sectionNames: ["Datos Generales", "Habilidades Digitales"],
        timerInterval: null,
        loading:true
      };
    },
    computed: {
      hasUnansweredQuestions() {
        if (!this.questionsBySection) return false;
        
        for (const sectionId in this.questionsBySection) {
          const hasIncomplete = this.questionsBySection[sectionId].some(question => {
            const reply = this.studentReply[question.id];
            
            if (question.type === 'multiple_choice') {
              // Para equipos, al menos uno seleccionado
              return !reply?.answerId?.length;
            }
            
            // Para preguntas de tipo single_choice
            return reply?.answerId === null || reply?.answerId === undefined;
          });
          
          if (hasIncomplete) return true;
        }
        
        return false;
      }
    },
    methods: {
			nextSection() {
				if (this.currentTab < this.sectionNames.length - 1) {
					this.currentTab ++;
				}
			},
      formatTime(seconds) {
        if (!seconds || seconds < 0) return 'N/A';

        const totalSeconds = Math.floor(seconds); // Redondear correctamente
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return minutes > 0
        ? `${minutes}m${remainingSeconds}s`
        : `${remainingSeconds}s`;
      },
      getQuestionStatus(questionId) {
        const reply = this.studentReply[questionId];
        const question = this.findQuestionById(questionId);
        
        if (!question || !reply) return false;
        
        if (question.type === 'multiple_choice') {
          // Para equipos, cualquier selección es válida (al menos uno)
          return reply.answerId && reply.answerId.length > 0;
        }
        
        // Para preguntas de tipo single_choice
        return reply.answerId !== null && reply.answerId !== undefined;
      },
      getQuestionStatusColor(questionId) {
        return this.getQuestionStatus(questionId) ? 'green' : 'orange';
      },
      isChecked(questionId, optionId) {
        return this.studentReply[questionId]?.answerId?.includes(optionId) || false;
      },
      findQuestionById(questionId) {
        for (const sectionId in this.questionsBySection) {
          const found = this.questionsBySection[sectionId].find(q => q.id === questionId);
          if (found) return found;
        }
        return null;
      },
      initializeAnswers() {
        // Inicializar todas las respuestas de todas las secciones
        for (const sectionId in this.questionsBySection) {
          this.questionsBySection[sectionId].forEach(question => {
            if (!this.studentReply[question.id]) {
              const baseStructure = { questionId: question.id };
              
              if (question.type === 'multiple_choice') {
                baseStructure.answerId = [];
              } else {
                baseStructure.answerId = null;
              }
              
              this.$set(this.studentReply, question.id, baseStructure);
            }
          });
        }
      },
      saveToLocalStorage() {
        const data = {
          studentReply: this.studentReply,
          timeSpent: this.timeSpent,
          currentTab: this.currentTab
        };
        localStorage.setItem(`habilidadesDigitales${this.$route.params.id}`, JSON.stringify(data));
      },
      loadFromLocalStorage() {
        const data = localStorage.getItem(`habilidadesDigitales${this.$route.params.id}`);
        if (data) {
          const parsed = JSON.parse(data);
          
          if (parsed.studentReply) {
            Object.keys(parsed.studentReply).forEach(qId => {
              this.$set(this.studentReply, qId, parsed.studentReply[qId]);
            });
          }
          
          this.timeSpent = parsed.timeSpent || 0;
          this.currentTab = parsed.currentTab || 0;
        }
      },
      validateSection(sectionId) {
        this.showError = {};
        let hasError = false;
        
        this.questionsBySection[sectionId].forEach(question => {
          const reply = this.studentReply[question.id];
          let isValid = true;
          
          if (question.type === 'multiple_choice') {
            // Para equipos, al menos uno seleccionado
            isValid = reply?.answerId?.length > 0;
          } else {
            // Para preguntas de tipo single_choice
            isValid = reply?.answerId !== null && reply?.answerId !== undefined;
          }
          
          if (!isValid) {
            this.$set(this.showError, question.id, true);
            hasError = true;
          }
        });
        
        return !hasError;
      },
      validateAllSections() {
        this.showError = {};
        let hasError = false;
        
        for (const sectionId in this.questionsBySection) {
          if (!this.validateSection(sectionId)) {
            hasError = true;
          }
        }
        
        return !hasError;
      },
      startTimer() {
        // Limpiar timer existente
        this.stopTimer();
        
        this.timerInterval = setInterval(() => {
          this.timeSpent++;
          this.saveToLocalStorage();
        }, 1000);
      },
      async checkExistingReply() {
          try {
              const response = await axios.get(`student/poll_reply/${this.$route.params.id}`);
              console.log(response)
              if (response.data.ok && response.data.reply) {
              // Si hay una respuesta, redirigir al estudiante o mostrar un mensaje
              Swal.fire({
                  title: 'Diagnóstico ya completado',
                  text: 'Ya has completado este diagnóstico anteriormente.',
                  icon: 'info',
              }).then(() => {
                  // Opción 2: Redirigir a la lista de diagnosticos
                  this.$router.push('/estudiante/asignaturas');
              });
              }
          } catch (error) {
              console.error('Error al verificar respuesta existente:', error);
          }
      },
      stopTimer() {
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
          this.saveToLocalStorage();
        }
      },
      async submit() {
        this.stopTimer();
        
        if (!this.validateAllSections()) {
          await Swal.fire({
            title: "¡Faltan respuestas!",
            html: "Por favor, contesta todas las preguntas antes de finalizar.",
            icon: "warning",
            confirmButtonText: "Entendido"
          });
          
          this.startTimer();
          return;
        }
        
        try {
          const result = await Swal.fire({
            title: "¿Desea terminar la evaluación?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí",
            cancelButtonText: "Volver"
          });
          
          if (result.isConfirmed) {
            await axios.post("student/poll_reply/" + this.$route.params.id, {
              answer: JSON.stringify(this.studentReply),
              points: 0, // Encuesta sin puntuación
              time: this.timeSpent
            });
            
            await Swal.fire("Completada!", "Las respuestas han sido guardadas correctamente", "success");
            localStorage.removeItem(`habilidadesDigitales${this.$route.params.id}`);
            this.$router.push('/estudiante/asignaturas');
          } else {
            this.startTimer();
          }
        } catch (error) {
          console.error('Error al enviar respuestas:', error);
          Swal.fire("Error", "No se pudieron guardar las respuestas", "error");
          this.startTimer();
        }
      }
    },
    async created() {
      try {
        await this.checkExistingReply();
        const response = await axios.get('/questionHabilidadesDigitales');
        this.questionsBySection = response.data.questionsBySection;
        this.instructions = response.data.instructions;
        
        this.initializeAnswers();
        this.loadFromLocalStorage();
        this.startTimer();
        this.loading = false;
      } catch (error) {
        console.error('Error cargando preguntas:', error);
        Swal.fire('Error', 'No se pudieron cargar las preguntas', 'error');
      }
    },
    beforeDestroy() {
      this.stopTimer();
    }
  };
  </script>